<el-dialog>
  <dialog
    #applicationDrawerDialog
    id="creatorApplicationDrawer"
    aria-labelledby="creator-application-drawer-title"
    class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">
    <el-dialog-backdrop
      (click)="closeDrawer()"
      class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200"></el-dialog-backdrop>

    <div
      tabindex="0"
      class="absolute inset-0 pl-10 focus:outline-none sm:pl-16 z-20"
      (click)="$event.stopPropagation()">
      <el-dialog-panel
        class="ml-auto block size-full max-w-md transform transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
        (click)="$event.stopPropagation()">
        @if (application(); as app) {
          <div class="relative flex h-full flex-col overflow-y-auto shadow-xl rounded-xl">
            <div class="h-full flex flex-col overflow-hidden divide-y divide-border">
              <!-- header -->
              <div class="px-2 py-4 drawer-header-primary">
                <div class="flex space-x-3 h-full items-center">
                  <div class="min-w-0 flex-1 px-2">
                    <p id="creator-application-drawer-title" class="text-md font-semibold text-primary m-0">
                      Application
                    </p>
                    <p class="text-sm text-secondary m-0">
                      Acting on behalf of a real creator.
                    </p>
                  </div>

                  <div class="h-full flex flex-col justify-between items-end">
                    <button type="button" (click)="closeDrawer()" class="fab-button-secondary text-secondary">
                      <span class="sr-only">Close</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="size-5"
                        aria-hidden="true">
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <!-- header - END -->

              <!-- main content -->
              <div
                class="relative h-full flex-1 flex-col items-center justify-center w-full overflow-hidden drawer-body-primary divide-y divide-border">
                <div class="h-full overflow-y-auto scrollbar-transparent py-4 px-4 space-y-4">
                  @if (app.brief?.campaign?.campaignPhoto) {
                    <div class="h-32 w-full overflow-hidden rounded-lg">
                      <atom-ldg-img
                        class="size-full"
                        [src]="imageService.getImageSource(app.brief!.campaign!.campaignPhoto, 'gallery_lg')"
                        inputClass="size-full object-cover"
                        radius="lg" />
                    </div>
                  }
                  
                  <div class="grid grid-cols-1 lg:grid-cols-2">
                    <div class="flex flex-col gap-y-3">
                      <div class="flex flex-col gap-y-1">
                        <p class="text-lg font-semibold text-primary">{{ briefTitle() }}</p>
                        <p class="text-sm text-secondary">{{ campaignName() }}</p>
                        <p class="text-sm text-secondary">{{ brandName() }}</p>
                      </div>
    
                      <div class="flex items-center gap-2">
                        <atom-application-status-badge [applicationStatus]="app.applicationStatus" />
                        @if (app.hiredEarnings != null && hiredCurrencyCode()) {
                          <p class="text-sm font-medium text-primary m-0">
                            {{ app.hiredEarnings | currency: hiredCurrencyCode() }}
                          </p>
                        }
                      </div>
                    </div>

                    <dl class="grid grid-cols-1 gap-2 text-sm m-0">
                      <div>
                        <dt class="text-secondary m-0">Created</dt>
                        <dd class="text-primary m-0">{{ app.createdDate | date: 'dd MMM yy HH:mm' }}</dd>
                      </div>
                      @if (app.applicationStatusModifiedDate) {
                        <div>
                          <dt class="text-secondary m-0">Status updated</dt>
                          <dd class="text-primary m-0">
                            {{ app.applicationStatusModifiedDate | date: 'dd MMM yy HH:mm' }}
                          </dd>
                        </div>
                      }
                    </dl>
                  </div>





                  <div class="w-full h-px bg-border my-4"></div>

                  @if (offerablePieceChannels().length > 0) {
                    <div class="flex flex-col gap-2">
                      <p class="m-0 text-sm text-secondary">
                        Social channels this creator is offering. UGC stays on the brief and is not an offer.
                      </p>
                      <div class="flex flex-wrap gap-2">
                        @for (channel of offerablePieceChannels(); track channel.id) {
                          <button
                            type="button"
                            [class]="channel.offered ? 'btn-shout btn-shout-xs btn-shout-primary shrink-0' : 'btn-shout btn-shout-xs btn-shout-tertiary shrink-0'"
                            [attr.aria-pressed]="channel.offered"
                            (click)="toggleOfferedChannel(channel.id)">
                            @if (channel.offered) {
                              {{ channel.label }}
                            } @else {
                              Offer {{ channel.label }}
                            }
                          </button>
                        }
                      </div>
                    </div>
                  }

                  <ins-creator-application-actions
                    [application]="app"
                    [actionLoading]="actionLoading()"
                    (apply)="apply()" />
                </div>
              </div>
              <!-- main content - END -->
            </div>
          </div>
        }
      </el-dialog-panel>
    </div>
  </dialog>
</el-dialog>
